// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardStatisticsMonthlyController = function ($scope, $routeParams, DashboardMonthly) {
    $scope.stats = {
        data: [],
        charts: {
            invoices: {
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d);
                    }
                }
            },
            activeContracts: {
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d);
                    }
                }
            },
            totalNetAmount: {
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('.2f')(d);
                    }
                }
            }
        }
    };

    $scope.currencies = [];
    $scope.sort = {
        by: 'NumberOfActiveContracts',
        reverse: true,
        currency: null
    };

    $scope.getSortValue = function (stat) {
        if ($scope.sort.by) {
            switch ($scope.sort.by) {
                case 'TotalNetAmount':
                    for (var i = 0; i < stat.BilledAmountByCurrency.length; i++) {
                        if (stat.BilledAmountByCurrency[i].Item1 === $scope.sort.currency) {
                            return stat.BilledAmountByCurrency[i].Item2;
                        }
                    }
                    break;
                default:
                    return stat[$scope.sort.by];
            }
        }
        return null;
    }

    var collectCurrencies = function (data) {

        var currencies = {};
        for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].BilledAmountByCurrency.length; j++) {
                currencies[data[i].BilledAmountByCurrency[j].Item1] = null;
            }
        }

        return Object.keys(currencies);
    };

    var getTopChartData = function (data, top, propName, xValue) {
        var result = [];

        var sortedDesc = data.slice(0).sort(function (a, b) { return b[propName] - a[propName] });
        var i = 0;
        for (; i <= top && i < sortedDesc.length && sortedDesc[i][propName] > 0; i++) {
            result.push({ key: sortedDesc[i].CustomerName, values: [[xValue, sortedDesc[i][propName]]] });
        }

        result.sort(function (a, b) { return a.values[0][1] > b.values[0][1]; })
        if (i < sortedDesc.length && sortedDesc[i][propName] > 0) {
            var others = 0;
            while (i < sortedDesc.length) others += sortedDesc[i++][propName];
            result.splice(0, 0, { key: 'others', values: [[xValue, others]] });
        }
        return result;
    };

    var getTotalNetAmountChartData = function (data, topCustomers, topCurrencies) {

        // 1. find top currencies
        var totalByCurrency = [];
        for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].BilledAmountByCurrency.length; j++) {
                var currency = data[i].BilledAmountByCurrency[j].Item1;

                var item = null;
                for (var k = 0; k < totalByCurrency.length; k++) {
                    if (totalByCurrency[k].currency === currency) {
                        item = totalByCurrency[k];
                        break;
                    }
                }

                if (!item) {
                    item = { currency: currency, value: 0 };
                    totalByCurrency.push(item);
                }

                item += data[i].BilledAmountByCurrency[j].Item2;
            }
        }

        var topCurrencies = totalByCurrency.sort(function (a, b) { return b.value - a.value; })
                                                   .slice(0, topCurrencies) // limit
                                                   .map(function (item) { return item.currency; }); // extract currencies

        // 2. calculate total net for customers
        var customersData = [];
        for (var i = 0; i < data.length; i++) {
            var item = { key: data[i].CustomerName, values: new Array(topCurrencies.length) }
            for (var j = 0; j < topCurrencies.length; j++) {

                var billedAmounts = data[i].BilledAmountByCurrency.filter(function (item) { return item.Item1 === topCurrencies[j]; });
                var billedAmount = billedAmounts.length > 0 ? billedAmounts[0].Item2 : 0;

                item.values[j] = billedAmount;
            }
            customersData.push(item);
        }

        var topCustomersData = {};

        // 3. find top customers
        for (var i = 0; i < topCurrencies.length; i++) {

            customersData.sort(function (a, b) { return b.values[i] - a.values[i]; });

            var j = 0;
            for (; j < topCustomers && j < customersData.length && customersData[j].values[i] > 0; j++) {
                if (!(customersData[j].key in topCustomersData)) {
                    topCustomersData[customersData[j].key] = new Array(topCurrencies.length);
                }

                topCustomersData[customersData[j].key][i] = customersData[j].values[i];
            }

            // calculate others
            if (j < customersData.length && customersData[j].values[i] > 0) {
                var others = 0;
                while (j < customersData.length) others += customersData[j++].values[i];
                if (!('others' in topCustomersData)) {
                    topCustomersData['others'] = new Array(topCurrencies.length);
                }
                topCustomersData['others'][i] = others;
            }
        }

        // 4. format data as charts require
        var result = [];
        for (var key in topCustomersData) {
            var values = new Array(topCurrencies.length);
            for (var i = 0; i < topCurrencies.length; i++) {
                values[i] = [topCurrencies[i], topCustomersData[key][i] ? topCustomersData[key][i] : null];
            }
            result.splice(0, 0, { key: key, values: values });
        }

        return result;
    };

    $scope.month = $routeParams.month;
    var date = new Date('01 ' + $routeParams.month); // $routeParams.month comes as month name and year, e.g. April 2014
    var data = DashboardMonthly.query({ year: date.getFullYear(), month: date.getMonth() + 1 }, function () {
        $scope.stats.data = data;
        $scope.currencies = collectCurrencies(data);
        $scope.sort.currency = $scope.currencies[0];

        $scope.stats.charts.invoices.data = getTopChartData(data, 5, 'NumberOfInvoices', 'Invoices');
        $scope.stats.charts.activeContracts.data = getTopChartData(data, 5, 'NumberOfActiveContracts', 'Active Contracts');
        $scope.stats.charts.totalNetAmount.data = getTotalNetAmountChartData(data, 5, 3);
    });
};

DashboardStatisticsMonthlyController.$inject = ['$scope', '$routeParams', 'DashboardMonthly'];
